import lazyLoading from "./lazyLoading";

export default {
  name: "download-dbpatients",
  path: "/download/dbpatients",
  component: lazyLoading("download/dbpatients/dbpatients"),
  meta: {
    default: false,
    title: "DB Pacijenti",
    class: "primary",
    show: false,
    iconClass: "fa fa-database",
    requiredAuth: true
  }
};



// WEBPACK FOOTER //
// ./src/store/modules/menu/dbpatients.js